import React from 'react';
import { Icon, Label } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import FileType, { FileTypeType } from '@constants/fileType';

function FileTypeLabel({
  fileType,
  customLabel,
}: {
  fileType: FileTypeType;
  customLabel?: string | number;
}) {
  const { t } = useTranslation();
  const labelColor = fileType === FileType.REPORT ? 'red' : 'green';
  const labelIcon = fileType === FileType.REPORT ? 'file pdf' : 'file excel';

  if (fileType === FileType.UNKNOWN) {
    return (
      <Label color="red">
        <Icon name="warning sign" />
        {customLabel ?? t(fileType.message)}
      </Label>
    );
  }

  return (
    <Label basic color={labelColor}>
      <Icon name={labelIcon} />
      {customLabel ?? t(fileType.message)}
    </Label>
  );
}

FileTypeLabel.defaultProps = {
  customLabel: undefined,
};

export default FileTypeLabel;
